// src/utils/saveProject.js
import pako from 'pako';
import { saveAs } from 'file-saver';

export const saveProjectToDisk = (projectInfo, rooms) => {
  const payload = { projectInfo, rooms };
  const compressed = pako.gzip(JSON.stringify(payload));
  const blob = new Blob([compressed], { type: 'application/gzip' });

  const now = new Date(projectInfo.dateTime || Date.now());
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const initials = projectInfo.assessor
    ? projectInfo.assessor.split(' ').map(n => n[0]?.toUpperCase()).join('')
    : 'NA';

  const filename = `${projectInfo.projectName || 'Untitled'}_${projectInfo.projectType || 'Project'}_${mm}-${dd}_${initials}.json.gz`;
  saveAs(blob, filename);
};

export const loadProjectFromFile = async (file) => {
  const buffer = await file.arrayBuffer();
  const decompressed = pako.ungzip(new Uint8Array(buffer), { to: 'string' });
  return JSON.parse(decompressed);
};